import React, { useEffect } from "react";
import { Card, Button, Container, Row, Col } from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css"; // Import AOS styles
import Acc from "./Acc";
import Cer_Tab from "./Cer_Tab";
import PC from "./PC";
import Edu from "./Edu";
import Extra from "./Extra";
import Badges from "./Badges";
import "./About.css";

function About() {
  useEffect(() => {
    // Scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

    // Initialize AOS animations
    AOS.init({
      duration: 1000, // animation duration (in ms)
      once: true, // play animation only once
      offset: 120, // offset from viewport before triggering
    });
  }, []);

  return (
    <div>
      <Container className="about-container py-5" data-aos="fade-up">
        <Card
          className="about-card shadow-sm border-0"
          data-aos="fade-up"
        >
          <Row className="align-items-center g-0">
            {/* Image Column */}
            <Col
              md={4}
              className="text-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <img
                className="about-image img-fluid rounded-circle"
                src="images/ne34.png"
                alt="Piyush Agarwal"
              />
            </Col>

            {/* Text Column */}
            <Col
              md={8}
              data-aos="fade-left"
              data-aos-delay="400"
            >
              <div className="about-card px-4 py-3">
                <h2
                  className="card-title fw-bold mb-3"
                  style={{ color: "#8f94fb" }}
                  data-aos="fade-up"
                  data-aos-delay="600"
                >
                  Hi, I'm Piyush Agarwal
                </h2>

                <p
                  className="card-text about-1"
                  data-aos="fade-up"
                  data-aos-delay="800"
                >
                  I'm a passionate Web Developer and Designer who loves crafting
                  interactive and user-friendly websites. I've worked across
                  frontend, backend, and creative fields — from React.js to
                  Graphic Design.
                  <br />
                  <br />
                </p>

                {/* Buttons Row */}
                <div
                  className="button-row mt-4"
                  data-aos="fade-up"
                  data-aos-delay="1000"
                >
                  <Button href="/Products" style={{marginRight:"1rem", backgroundColor:"#4e54c8"}}>
                    💻 View Projects
                  </Button>
                  <Button href="/Contact" variant="secondary" style={{marginRight:"1rem"}}>
                    📩 Contact Me
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Card>
      </Container>

      <br />

      {/* Other Sections */}
      <div className="internship-insight-card">
      <Acc />
      </div>
      <br></br>
      {/* <Cer_Tab /> */}
      <PC />
      <Edu />
      <Badges />
      <Extra />
    </div>
  );
}

export default About;
